import { AboutSection, Grid, H2, Body, InfoCard, Bullet } from "./About.styled";

export default function About() {
  return (
    <AboutSection id="about">
      <Grid>
        <div>
          <H2>About Piersoft Technologies</H2>
          <Body>
            Piersoft Technologies builds digital infrastructure for
            construction. We simplify complex, paper intensive workflows and
            turn them into governed, auditable processes with clear
            accountability.
          </Body>
          <Body>
            <strong>Portal 360</strong> unifies project setup, procurement,
            mobility, and site security in a single digital ecosystem. Start
            with the features you need today and scale to the complete platform
            as your digital capabilities grow.
          </Body>
        </div>
        <div>
          <InfoCard>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <Bullet>
                Grounded in on site and office workflows that teams actually
                use.
              </Bullet>
              <Bullet>
                Seamless integration with ERP systems and third party tools.
              </Bullet>
            </ul>
          </InfoCard>
        </div>
      </Grid>
    </AboutSection>
  );
}
